<template>
    <div>
      <div class="a-tab__title-block admin__a-tab">
        <h3>{{$t('form.tender.tender-status')}}</h3>
      </div>
      <div class="a-container-form ">
        <div class="a-label">{{$t('labels.status')}}:</div>
        <p class="a-input a-input--disabled">{{$t(tender.status.label)}}</p>
        <span type="button" class="gui-btn-none-style"
              @click="onTenderSignCheckClick()"
              v-if="tender.hasSign">
            <img class="accreditation__reg-img" src="@/assets/img/static/b-icon_edit.svg" alt="">
        </span>
      </div>
      <div class="a-container-form" v-if="tender.status.DECLINED">
        <div class="a-label ">{{$t('labels.reason-for-rejection')}}:</div>
          <p class="a-input a-input--disabled">{{tender.reason}}</p>
      </div>
      <div class="a-container-form ">
        <div class="a-label">{{$t('labels.last-modified-date')}}</div>
        <date-time class="a-input a-input--disabled" :value="tender.modifiedTime"></date-time>
      </div>

      <div class="a-tab__title-block admin__a-tab">
        <h3>{{$t('form.tender.general-information')}}</h3>
      </div>

      <div class="a-container-form  ">
        <div class="a-label a-label--w-280">{{$t('form.tender.customer-details')}}:</div>
        <p class="a-input a-input--disabled">{{customerTitle}}</p>
      </div>
      <div class="a-container-form a-container-form--align-start a-mandatory">
        <div class="a-label a-label--w-280">{{$t('form.tender.initiator-contact-details')}}:</div>
        <dropdown-new v-model="tender.owner.id" :options="organizers" class="select-w-260" v-if="CanEditOwner" @change="checkForm($event, CanEditOwner)"></dropdown-new>
        <p class="a-input a-input--disabled" v-else>
          {{tender.owner | fullName}}
          <br> {{tender.owner.email}}
          <br> {{tender.owner.phone}}
        </p>
      </div>
      <div class="a-container-form">
        <div class="a-label a-label--w-280">{{$t('form.tender.address')}}: </div>
        <p class="a-input a-input--disabled ">{{customerAddress}}</p>
      </div>
      <div class="a-container-form  a-container-form--align-start">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-creation-datetime')}}:</div>
        <date-time class="a-input a-input--disabled" :value="tender.creationTime"></date-time>
      </div>
      <div class="a-container-form admin-buy__block a-mandatory">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-name')}}:</div>
        <input type="text" class="a-input a-input--w-280" :placeholder="$t('form.tender.tender-name-placeholder')" v-model="tender.name" v-if="CanEditName" @blur="checkForm">
        <p class="a-input a-input--disabled " v-else>{{tender.name || 'Не указан'}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-mandatory">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-number')}}:</div>
        <input type="text" class="a-input a-input--w-280" :placeholder="$t('form.tender.tender-number-placeholder')" v-model="tender.number" v-if="CanEditTenderNumber" @blur="checkForm">
        <p class="a-input a-input--disabled " v-else>{{tender.number || 'Не указан'}}</p>
      </div>

      <div class="a-container-form a-container-form--align-start a-mandatory">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-publish-date')}}:</div>
        <div class="a-flex-start a-width-100-percent">
          <template v-if="CanEditPublicationTime">
            <dropdown-new v-model="tender.publication.mode"  class="select-w-280" @change="checkForm">
              <option value :label="'tender-publication-mode.empty'"></option>
              <option :value="enums.TenderPublicationMode.DEFERRED" :label="'tender-publication-mode.deferred'"></option>
              <option :value="enums.TenderPublicationMode.NOW" :label="'tender-publication-mode.now'"></option>
            </dropdown-new>
            <div class="a-width-100-percent a-flex-start u-margin-top-24" v-if="tender.publication.mode == enums.TenderPublicationMode.DEFERRED">
              <div class="a-input-group ">
                <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
                <date-picker v-model="publication.date" @change="checkForm"></date-picker>
              </div>
              <div class="a-input-group ">
                <div class="a-input-group__prepend "><img src="@/assets/img/static/time.svg" alt=""></div>
                <cleave v-model="publication.time" :options="time" @blur="checkForm"></cleave>
              </div>
            </div>
          </template>
          <template v-else>
            <date-time :value="tender.publication.time"></date-time>
          </template>
        </div>
      </div>

      <div class="a-block-changes-label-padding">
        <div class="a-container-form a-container-form--align-start a-mandatory">
          <div class="a-label a-label--w-280">{{$t('form.tender.request-receiving-duration')}}:</div>
          <div class="a-flex-start" v-if="CanEditDurations">
            <div class="a-input-text-after-before">
              <p>{{$t('form.tender.planned-duration')}}</p>
              <input-number
                     placeholder="число"
                     v-model="tender.durations.receivingRequests.value"
                     @change="onDependentDurationChange"></input-number>
              <p>{{$t('labels.calendar_days')}}</p>
            </div>
          </div>
          <p class="a-input a-input--disabled " v-else>{{$t('form.tender.planned-duration-in-calendar-days', {days: tender.durations.receivingRequests.value})}}</p>
        </div>
        <div class="a-container-form a-container-form--align-start a-mandatory">
          <div class="a-label a-label--w-280">{{$t('form.tender.request-reviewing-duration')}}:</div>
          <div class="a-flex-start" v-if="CanEditDurations">
            <div class="a-input-text-after-before">
              <p>{{$t('form.tender.planned-duration')}}</p>
              <input-number
                     placeholder="число"
                     v-model="tender.durations.reviewingRequests.value"
                     @change="onDependentDurationChange"></input-number>
              <p>{{$t('labels.calendar_days')}}</p>
            </div>
            <div class="a-checkbox a-width-100-percent u-margin-top-24">
              <label class="a-checkbox__label">
                <input class="a-checkbox__input" type="checkbox" :disabled="!CanEditShowDuration" v-model="tender.durations.reviewingRequests.isPublic" @change="checkForm">
                <span class="a-checkbox__icon"></span>
                <span class="a-checkbox__text">{{$t('form.tender.show-in-public-part')}}</span>
              </label>
            </div>
          </div>
          <p class="a-input a-input--disabled " v-else>{{$t('form.tender.planned-duration-in-calendar-days', {days: tender.durations.reviewingRequests.value})}}</p>
        </div>
        <div class="a-container-form a-container-form--align-start a-mandatory">
          <div class="a-label a-label--w-280">{{$t('form.tender.request-reviewing-by-criteria-duration')}}:</div>
          <div class="a-flex-start" v-if="CanEditDurations">
            <div class="a-input-text-after-before">
              <p>{{$t('form.tender.planned-duration')}}</p>
              <input-number
                     placeholder="число"
                     v-model="tender.durations.reviewingRequestsByCriteria.value"
                     @change="onDependentDurationChange"></input-number>
              <p>{{$t('labels.calendar_days')}}</p>
            </div>
            <div class="a-checkbox a-width-100-percent u-margin-top-24">
              <label class="a-checkbox__label">
                <input class="a-checkbox__input" type="checkbox" :disabled="!CanEditShowDuration" v-model="tender.durations.reviewingRequestsByCriteria.isPublic" @change="checkForm">
                <span class="a-checkbox__icon"></span>
                <span class="a-checkbox__text">{{$t('form.tender.show-in-public-part')}}</span>
              </label>
            </div>
          </div>
          <p class="a-input a-input--disabled " v-else>{{$t('form.tender.planned-duration-in-calendar-days', {days: tender.durations.reviewingRequestsByCriteria.value})}}</p>
        </div>
        <div class="a-container-form a-container-form--align-start a-mandatory">
          <div class="a-label a-label--w-280">{{$t('form.tender.first-retend-waiting-duration')}}:</div>
          <div class="a-flex-start" v-if="CanEditDurations">
            <div class="a-input-text-after-before">
              <p>{{$t('form.tender.planned-duration')}}</p>
              <input-number
                     placeholder="число"
                     v-model="tender.durations.waitingForFirstRetend.value"
                     @change="onDependentDurationChange"></input-number>
              <p>{{$t('labels.calendar_days')}}</p>
            </div>
            <div class="a-checkbox a-width-100-percent u-margin-top-24">
              <label class="a-checkbox__label">
                <input class="a-checkbox__input" type="checkbox" :disabled="!CanEditShowDuration" v-model="tender.durations.waitingForFirstRetend.isPublic" @change="checkForm">
                <span class="a-checkbox__icon"></span>
                <span class="a-checkbox__text">{{$t('form.tender.show-in-public-part')}}</span>
              </label>
            </div>
          </div>
          <p class="a-input a-input--disabled " v-else>{{$t('form.tender.planned-duration-in-calendar-days', {days: tender.durations.waitingForFirstRetend.value})}}</p>
        </div>
        <div class="a-container-form a-container-form--align-start a-mandatory">
          <div class="a-label a-label--w-280">{{$t('form.tender.cost-dividing-duration')}}:</div>
          <div class="a-flex-start" v-if="CanEditDurations">
            <div class="a-input-text-after-before">
              <p>{{$t('form.tender.planned-duration')}}</p>
              <input-number
                     placeholder="число"
                     v-model="tender.durations.splittingPrice.value"
                     @change="onDependentDurationChange"></input-number>
              <p>{{$t('labels.calendar_days')}}</p>
            </div>
            <div class="a-checkbox a-width-100-percent u-margin-top-24">
              <label class="a-checkbox__label">
                <input class="a-checkbox__input" type="checkbox" :disabled="!CanEditShowDuration" v-model="tender.durations.splittingPrice.isPublic" @change="checkForm">
                <span class="a-checkbox__icon"></span>
                <span class="a-checkbox__text">{{$t('form.tender.show-in-public-part')}}</span>
              </label>
            </div>
          </div>
          <p class="a-input a-input--disabled " v-else>{{$t('form.tender.planned-duration-in-calendar-days', {days: tender.durations.splittingPrice.value})}}</p>
        </div>
        <div class="a-container-form a-container-form--align-start a-mandatory">
          <div class="a-label a-label--w-280">{{$t('form.tender.total-tender-duration')}}:</div>
          <div class="a-flex-start" v-if="CanEditDurations">
            <div class="a-input-text-after-before">
              <p>{{$t('form.tender.planned-duration')}}</p>
              <input-number
                     placeholder="число"
                     v-model="tender.durations.tender.value"
                     @change="checkForm"></input-number>
              <p>{{$t('labels.calendar_days')}}</p>
            </div>
            <div class="a-checkbox a-width-100-percent u-margin-top-24">
              <label class="a-checkbox__label">
                <input class="a-checkbox__input" type="checkbox" :disabled="!CanEditShowDuration" v-model="tender.durations.tender.isPublic" @change="checkForm">
                <span class="a-checkbox__icon"></span>
                <span class="a-checkbox__text">{{$t('form.tender.show-in-public-part')}}</span>
              </label>
            </div>
          </div>
          <p class="a-input a-input--disabled " v-else>{{$t('form.tender.planned-duration-in-calendar-days', {days: tender.durations.tender.value})}}</p>
        </div>
        <div class="a-container-form a-container-form--align-start a-mandatory">
          <div class="a-label a-label--w-280">{{$t('form.tender.contract-conclusion-duration')}}:</div>
          <div class="a-flex-start" v-if="CanEditDurations">
            <div class="a-input-text-after-before">
              <p>{{$t('form.tender.planned-duration')}}</p>
              <input-number
                     placeholder="число"
                     v-model="tender.durations.contractConclustion.value"
                     @change="onDependentDurationChange"></input-number>
              <p>{{$t('labels.calendar_days')}}</p>
            </div>
            <div class="a-checkbox a-width-100-percent u-margin-top-24">
              <label class="a-checkbox__label">
                <input class="a-checkbox__input" type="checkbox" :disabled="!CanEditShowDuration" v-model="tender.durations.contractConclustion.isPublic" @change="checkForm">
                <span class="a-checkbox__icon"></span>
                <span class="a-checkbox__text">{{$t('form.tender.show-in-public-part')}}</span>
              </label>
            </div>
          </div>
          <p class="a-input a-input--disabled " v-else>{{$t('form.tender.planned-duration-in-calendar-days', {days: tender.durations.contractConclustion.value})}}</p>
        </div>
      </div>

      <div class="a-container-form a-mandatory">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-method')}}:</div>
        <dropdown-new :value="tender.method" class="select-w-280" v-if="CanEditTenderMethod" @change="OnMethodChanged">
          <option value :label="'tender-method.empty'"></option>
          <option :value="enums.TenderMethod.TENDER" :label="'tender-method.tender'"></option>
          <option :value="enums.TenderMethod.REQUEST_FOR_PRICE" :label="'tender-method.request-for-price'"></option>
          <option :value="enums.TenderMethod.REQUEST_FOR_PROPOSALS" :label="'tender-method.request-for-proposals'"></option>
          <option :value="enums.TenderMethod.ONE" :label="'tender-method.one'"></option>
          <option :value="enums.TenderMethod.REDUCTION" :label="'tender-method.reduction'"></option>
        </dropdown-new>
        <p class="a-input a-input--disabled " v-else>{{$t(tender.method.label)}}</p>
      </div>


      <template v-if="tender.method == enums.TenderMethod.REDUCTION">
        <div class="a-tab__title-block admin__a-tab">
          <h3>{{$t('form.tender.details-about-price-criteria')}}</h3>
        </div>

        <price-criteria-configuration v-model="tender" :criteria="priceCriteria" @input="checkForm"></price-criteria-configuration>
        <price-criteria-formula :value="tender" @input="checkForm" ></price-criteria-formula>
      </template>


      <template v-if="tender.method.valueOf() == enums.TenderMethod.REDUCTION">
        <div class="a-tab__title-block admin__a-tab">
          <h3>{{$t('form.tender.details-about-reduction-criteria')}}</h3>
        </div>

        <reduction-criteria-configuration v-model="tender" :criteria="reductionCriteria" @input="checkForm"></reduction-criteria-configuration>

<!--        <div class="a-container-form" v-for="(t, idx) in tender.criteria.reduction">-->
<!--          <div class="a-label a-label&#45;&#45;auto">{{idx + 1}}.</div>-->
<!--          <template v-if="CanEditCriteria">-->
<!--            <dropdown-new class="select-w-755" :options="reductionCriteria" v-model="tender.criteria.reduction[idx].id" @change="checkForm"></dropdown-new>-->

<!--            <dropdown-new  class="select-w-180 u-margin-left-20"-->
<!--                           v-model="tender.criteria.reduction[idx].unit"-->
<!--                           @input="checkForm"-->
<!--                           v-if="tender.method == enums.TenderMethod.REDUCTION">-->
<!--              <option value :label="'assessment-unit.empty'"></option>-->
<!--              <option :value="enums.AssessmentUnit.LOT" :label="'assessment-unit.lot'"></option>-->
<!--              <option :value="enums.AssessmentUnit.CATALOG" :label="'assessment-unit.catalog'"></option>-->
<!--            </dropdown-new>-->

<!--            <button class="admin-buy__img-rip" type="button" @click="tender.criteria.reduction.splice(idx, 1) && checkForm()">-->
<!--              <img src="@/assets/img/static/trashcan.svg" alt="">-->
<!--            </button>-->
<!--          </template>-->
<!--          <p class="a-input a-input&#45;&#45;disabled " v-else>{{t.criterionName}}</p>-->
<!--        </div>-->
<!--        <div class="a-container-form " v-if="CanEditCriteria">-->
<!--          <button class="gui-btn gui-btn&#45;&#45;red gui-btn&#45;&#45;w-230" type="button" @click="tender.criteria.reduction.push({})">{{$t('buttons.add-reduction-criterion')}}</button>-->
<!--        </div>-->
      </template>



      <template v-if="tender.method != enums.TenderMethod.EMPTY && tender.method != enums.TenderMethod.REQUEST_FOR_PRICE">
        <div class="a-tab__title-block admin__a-tab">
          <h3>{{$t('form.tender.details-about-expert-criteria')}}</h3>
        </div>
        <div class="a-container-form" v-for="(t, idx) in tender.criteria.expert">
          <div class="a-label a-label--auto">{{idx + 1}}.</div>
          <template v-if="CanEditCriteria">
            <dropdown-new class="select-w-755" :options="expertCriteria" v-model="tender.criteria.expert[idx].id" @change="checkForm"></dropdown-new>

            <dropdown-new  class="select-w-180 u-margin-left-20"
                           v-model="tender.criteria.expert[idx].unit"
                           @input="checkForm"
                           v-if="tender.method == enums.TenderMethod.REDUCTION">
              <option value :label="'assessment-unit.empty'"></option>
              <option :value="enums.AssessmentUnit.LOT" :label="'assessment-unit.lot'"></option>
              <option :value="enums.AssessmentUnit.CATALOG" :label="'assessment-unit.catalog'"></option>
            </dropdown-new>

            <button class="admin-buy__img-rip" type="button" @click="tender.criteria.expert.splice(idx, 1) && checkForm()">
              <img src="@/assets/img/static/trashcan.svg" alt="">
            </button>
          </template>
          <p class="a-input a-input--disabled " v-else>{{t.criterionName}}</p>
        </div>
        <div class="a-container-form " v-if="CanEditCriteria">
          <button class="gui-btn gui-btn--red gui-btn--w-230" type="button" @click="tender.criteria.expert.push({})">{{$t('buttons.add-expert-criterion')}}</button>
        </div>
      </template>

      <template v-if="tender.method != enums.TenderMethod.EMPTY">
        <div class="a-tab__title-block admin__a-tab">
          <h3>{{$t('form.tender.details-about-weight-in-present-price')}}</h3>
        </div>
        <section v-maximizable>
         <div class="table-tab table-tab--media460-responsible table-tab--th-row-none u-padding-b-24">
          <div class="table-tab__container">
            <table class="table-tab__block table">
              <thead class="table-tab__thead">
              <tr class="table-tab__tr">
                <th class=" table-tab__th--row">№</th>
                <th>{{$t('form.tender.present-price-table.criterion')}}</th>
                <th>{{$t('form.tender.present-price-table.present-price')}}</th>
                <th>{{$t('form.tender.present-price-table.actions')}}</th>
              </tr>
              </thead>
              <tbody class="table-tab__tbody">
              <tr v-for="(criteria, idx) in tender.criteria.expert">
                <th class="table-tab__th--row">
                  {{idx + tender.criteria.price.length + 1}}
                </th>
                <td>{{criteria.criterionName}}</td>
                <!--<td>{{criteria.weight}}</td>-->
                <td>
                  <!--<input type="tel" class="a-input" data-mask="000" placeholder="число" >-->
                  <input-percent class="a-input" v-model="tender.criteria.expert[idx].weight" v-if="CanEditCriteria" @blur="checkForm"></input-percent>
                  <span v-else>{{criteria.weight | percent}}</span>
                </td>
                <td>
                  <button class="admin-buy__img-rip" type="button" v-if="CanEditCriteria">
                    <img src="@/assets/img/static/b-icon_edit.svg" alt="">
                  </button>
                </td>
              </tr>

              <tr v-for="(criteria, idx) in tender.criteria.reduction">
                <th class="table-tab__th--row">
                  {{idx + tender.criteria.price.length + 1}}
                </th>
                <td>{{criteria.criterionName}}</td>
                <!--<td>{{criteria.weight}}</td>-->
                <td>
                  <!--<input type="tel" class="a-input" data-mask="000" placeholder="число" >-->
                  <input-percent class="a-input" v-model="tender.criteria.reduction[idx].weight" v-if="CanEditCriteria" @blur="checkForm"></input-percent>
                  <span v-else>{{criteria.weight | percent}}</span>
                </td>
                <td>
                  <button class="admin-buy__img-rip" type="button" v-if="CanEditCriteria">
                    <img src="@/assets/img/static/b-icon_edit.svg" alt="">
                  </button>
                </td>
              </tr>

              <tr class="table-tab__background-color" v-for="(criteria, idx) in tender.criteria.reducedPrice">
                <th class="table-tab__th--row">
                </th>
                <td class="table-tab__color">{{$t('form.tender.present-price-table.present-price')}}</td>
                <!--<td>{{criteria.weight}}</td>-->
                <td>
                  <!--<input type="tel" class="a-input" data-mask="000" placeholder="число" v-model="tender.criteria.reducedPrice[idx].weight" v-if="CanEditCriteria"  @blur="checkForm">-->
                  <input-percent class="a-input" v-model="tender.criteria.reducedPrice[idx].weight" v-if="CanEditCriteria" @blur="checkForm"></input-percent>
                  <span v-else>{{criteria.weight | percent}}</span>
                </td>
                <td>
                  <button class="admin-buy__img-rip" type="button" v-if="CanEditCriteria">
                    <img src="@/assets/img/static/b-icon_edit.svg" alt="">
                  </button>
                </td>
              </tr>
              <tr class="table-tab__tr">
                <th class="table-tab__th--row">
                </th>
                <td class="table-tab__color">{{$t('form.tender.present-price-table.total')}}</td>
                <td>
                  <div class="a-form-field">
                    <div>{{totalWeight | percent}}%</div>
                    <span class="a-validation-error" v-if="totalWeight != 10000">{{$t('validation-error.sum-of-percent-should-be-100')}}</span>
                  </div>
                </td>
                <td>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        </section>
      </template>

      <div class="a-tab__title-block admin__a-tab">
        <h3>{{$t('form.tender.commission-members')}}</h3>
      </div>
      <div class="a-container-form a-mandatory">
        <div class="a-label ">{{$t('form.tender.commission-chairman')}}:</div>
        <dropdown-new class="select-w-570" v-if="CanEditCommission" :options="possibleMembers" v-model="tender.commission.chairman.id" @change="checkForm">
          <option value :label="'tender-commission-member.empty'"></option>
        </dropdown-new>
        <p class="a-input a-input--disabled " v-else>{{tender.commission.chairman | fullName}}</p>
      </div>
      <div class="a-container-form">
        <div class="a-label ">{{$t('form.tender.commission-deputy-chairman')}}:</div>
        <dropdown-new class="select-w-570" v-if="CanEditCommission" :options="possibleMembers" v-model="tender.commission.deputyChairman.id" @change="checkForm">
          <option value :label="'tender-commission-member.empty'"></option>
        </dropdown-new>
        <p class="a-input a-input--disabled " v-else>{{tender.commission.deputyChairman | fullName}}</p>
      </div>
      <div class="a-container-form a-mandatory">
        <div class="a-label ">{{$t('form.tender.commission-secretary')}}:</div>
        <dropdown-new class="select-w-570" v-if="CanEditCommission" :options="possibleMembers" v-model="tender.commission.secretary.id" @change="checkForm">
          <option value :label="'tender-commission-member.empty'"></option>
        </dropdown-new>
        <p class="a-input a-input--disabled " v-else>{{tender.commission.secretary | fullName}}</p>
      </div>
      <div class="a-container-form ">
        <div class="a-label ">{{$t('form.tender.commission-members')}}:</div>
        <template v-if="tender.commission.other.length > 0">
          <dropdown-new class="select-w-570" v-if="CanEditCommission" :options="possibleMembers" v-model="tender.commission.other[0].id" @change="checkForm"></dropdown-new>
          <p class="a-input a-input--disabled " v-else>{{tender.commission.other[0] | fullName}}</p>

          <button class="admin-buy__img-rip"
                  v-if="CanEditCommission"
                  @click.prevent="onRemoveOtherCommissionMemberClick(0)">
            <img src="@/assets/img/static/trashcan.svg" alt="">
          </button>
        </template>
      </div>
      <div class="a-container-form" v-if="idx > 0" v-for="(m, idx) in tender.commission.other">
        <div class="a-label "></div>
        <dropdown-new class="select-w-570" v-if="CanEditCommission" :options="possibleMembers" v-model="tender.commission.other[idx].id" @change="checkForm"></dropdown-new>
        <p class="a-input a-input--disabled " v-else>{{tender.commission.other[idx] | fullName}}</p>

        <button class="admin-buy__img-rip"
                v-if="CanEditCommission"
                @click.prevent="onRemoveOtherCommissionMemberClick(idx)">
          <img src="@/assets/img/static/trashcan.svg" alt="">
        </button>
      </div>
      <div class="a-container-form " v-if="CanEditCommission">
        <div class="a-label "></div>
        <button class="gui-btn gui-btn--red gui-btn--w-247" type="button" @click="tender.commission.other.push({})">{{$t('buttons.add-member-to-commission')}}</button>
      </div>

      <div class="a-tab__title-block admin__a-tab a-mandatory">
        <h3>{{$t('form.tender.details-about-requested-documents')}}</h3>
      </div>

      <template v-for="(doc, idx) in tender.documents">
        <div class="a-container-form u-padding-bottom-12">
          <div class="a-label a-label--w-30">{{idx + 1}}.</div>
          <dropdown-new class="select-w-755"
                        :options="availableDocuments"
                        :placeholder="'labels.document-not-selected'"
                        v-model="tender.documents[idx].document.id"
                        @change="checkForm"
                        v-if="CanEditDocuments"></dropdown-new>
          <p class="a-input a-input--disabled " v-else>{{tender.documents[idx].document.name}}</p>

          <button class="admin-buy__img-rip" v-if="CanEditDocuments" @click.prevent="onRequiredDocumentRemoved(idx)">
            <img src="@/assets/img/static/trashcan.svg" alt="">
          </button>
        </div>

        <div class="a-container-form">
          <div class="a-label a-label--w-215"></div>
          <dropdown-new class="select-w-570"
                        :options="enums.TenderDocumentType.options.all"
                        v-model="tender.documents[idx].type"
                        @change="checkForm"
                        v-if="CanEditDocuments"></dropdown-new>
          <p class="a-input a-input--disabled " v-else>{{$t(tender.documents[idx].type.label)}}</p>
        </div>

        <div class="a-container-form a-container-form--align-start" style="padding-left: 25px;" v-if="tender.documents[idx].document.passport">
          <div class="a-label a-label--w-280" style="padding-top: 12px;">{{$t('form.tender.choose-period-for-notifying-of-the-org-about-expiration-of-power-of-attorney')}}</div>
          <template v-if="CanEditDocuments">
            <input-number class="a-input a-input--w-100" v-model="tender.durations.remind" @blur="checkForm"></input-number>
            <p class="u-padding-left-20" style="padding-top: 8px;">{{$t('labels.calendar_days')}}</p>
          </template>
          <p class="a-input a-input--disabled " v-else>{{$tc('labels.n_calendar_days', tender.durations.remind)}}</p>
        </div>
      </template>

      <div class="a-container-form " v-if="CanEditDocuments">
        <button class="gui-btn gui-btn--red gui-btn--w-230" @click.prevent="addRequiredDocument">{{$t('buttons.add-document')}}</button>
      </div>


      <div class="a-tab__title-block admin__a-tab a-mandatory">
        <h3>{{$t('form.tender.lots-in-tender')}}</h3>
      </div>

      <div class="a-container-form" v-for="(lot, idx) in tender.lots">
        <div class="a-label a-label--auto">{{idx + 1}}.</div>
        <dropdown-new class="select-w-570" :options="lots" v-model="tender.lots[idx].id" @change="checkForm" v-if="lot.isNew"></dropdown-new>
        <p class="a-input a-input--disabled " v-else>№{{lot.num}} {{lot.name}}</p>

        <router-link class="gui-btn gui-btn--red u-margin-left-20 media-class-a" :to="{name: 'purchases-lot-details', params: { lotId: tender.lots[idx].id, tab: 'overview'}}">{{$t('buttons.review-lot')}}</router-link>
        <button class="admin-buy__img-rip" type="button" @click="tender.lots.splice(idx, 1) && checkForm()" v-if="CanEditLots">
          <img src="@/assets/img/static/trashcan.svg" alt="">
        </button>
      </div>

      <div class="a-container-form " v-if="CanEditLots">
        <button class="gui-btn gui-btn--red gui-btn--w-184" type="button" @click="tender.lots.push({isNew: true})" >{{$t('buttons.add-lot')}}</button>
      </div>


      <div class="a-tab__title-block admin__a-tab">
        <h3>{{$t('form.tender.other')}}</h3>
      </div>
      <div class="a-checkbox">
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="tender.isOrganizerSignatureRequired" @change="checkForm" :disabled="!CanEditOtherOptions">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">{{$t('form.tender.owner-should-use-signature')}}</span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="tender.isParticipantSignatureRequired" @change="checkForm" :disabled="!CanEditOtherOptions">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">{{$t('form.tender.participant-should-use-signature')}}</span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="tender.doShowWeights" @change="checkForm" :disabled="!CanEditOtherOptions">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">{{$t('form.tender.show-weights-to-participant-in-public-part')}}</span>
        </label>
      </div>

      <div class="a-tab__title-block admin__a-tab a-mandatory">
        <h3>{{$t('form.tender.tender-documents')}}</h3>
      </div>
      <div class="a-container-form ">
        <div class="a-input-file-block">
          <file-link :name="doc.name"
                     :size="doc.size"
                     :link="externalLink(doc.uid)"
                     :removable="CanEditDocumentation"
                     :key="doc.id"
                     :signed="doc.hasSign"
                     @remove="onFileRemoveClick(doc.id)"
                     @onsigncheck="onFileSignCheckClick(doc.id)"
                     v-for="doc in tender.files">
          </file-link>

          <template v-if="CanEditDocumentation">
            <file-picker :mode="tender.files.length === 0 ? 'link': 'button'"
                         @prepared="onFileReady($event)">
            </file-picker>
          </template>
        </div>
      </div>

      <div class="a-container-form admin-buy__block"
           :class="{'a-input-group--error': $v.tender.reason.$error}"
           v-if="tender.permissions.CAN_REJECT_TENDER">
        <div class="a-label ">{{$t('form.tender.reason-for-rejection')}}</div>
        <div class="a-form-field a-width-100-percent">
          <textarea class="a-textarea" rows="2" placeholder="" v-model="tender.reason"></textarea>
          <span class="a-validation-error" v-if="$v.tender.reason.$error">{{$t('validation-error.specify-reason')}}</span>
        </div>
      </div>

      <div class="a-container-form admin-buy__block a-mandatory" v-if="CanChangeDescription">
        <div class="a-label a-label--w-280">{{$t('form.tender.changes-description')}}</div>
        <div class="a-form-field a-width-100-percent">
          <textarea class="a-textarea"
                    rows="2"
                    v-model="tender.changeDescription"
                    @change="checkForm">
          </textarea>
          <span class="a-validation-error" v-if="$v.tender.changeDescription.$dirty && !$v.tender.changeDescription.required">{{$t('validation-error.specify-changes-description')}}</span>
        </div>
      </div>
      <div class="a-container-form admin-buy__block" v-else-if="tender.changeDescription">
        <div class="a-label a-label--w-280">{{$t('form.tender.changes-description')}}:</div>
        <span class="a-input a-input--disabled u-red-color">{{tender.changeDescription}}</span>
      </div>

      <div class="personal- data__btn-block admin-buy__block-gui-btn a-flex-start">
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="tender.isFilled && tender.permissions.CAN_SEND_TENDER_FOR_APPROVAL" @click="onSignTenderClick">{{$t('buttons.send-tender-for-approval')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="tender.permissions.CAN_APPROVE_TENDER" @click="approveTender">{{$t('buttons.approve-tender')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="tender.permissions.CAN_REJECT_TENDER" @click="declineTender">{{$t('buttons.reject-tender')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="tender.isFilled && tender.permissions.CAN_PUBLISH_TENDER" @click="onSignTenderClick">{{$t('buttons.publish-tender')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-207" type="button" :disabled="saveButtonDisabled" v-if="tender.permissions.CAN_MANUALLY_SAVE_LOT" @click="updateTender">{{$t('buttons.save-changes-in-tender')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="tender.permissions.CAN_DELETE_TENDER" @click="deleteTender">{{$t('buttons.delete-tender')}}</button>
      </div>

      <signing-dialog ref="signTender"
                      @signed="publishTender">
      </signing-dialog>

      <signature-details-dialog ref="signCheck"></signature-details-dialog>
      <loading v-if="loading"></loading>
    </div>
</template>

<script>
  import _ from 'lodash'
  import { requiredIf } from '@/validators'

  import Cleave from 'vue-cleave-component';
  import SigningDialog from '@/components/common/dialogs/SigningDialog'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import PriceCriteriaConfiguration from './reduction/PriceCriteriaConfiguration'
  import PriceCriteriaFormula from './reduction/PriceCriteriaFormula';
  import ReductionCriteriaConfiguration from "./reduction/ReductionCriteriaConfiguration";

  function compareArrays(a,b) {
    for (let i = 0; i < Math.min(a.length, b.length); ++i) {
      if (a[i] != b[i]) {
        return a[i] - b[i];
      }
    }

    return a.length - b.length;
  }

  export default {
    props: {
      tender: Object
    },

    components: {
      ReductionCriteriaConfiguration,
      PriceCriteriaFormula,
      SigningDialog,
      SignatureDetailsDialog,
      Cleave,
      PriceCriteriaConfiguration
    },

    data: () => ({
      canEdit: true,
      possibleMembers: [],
      availableMembers: [],
      organizers: [],
      documents: [],
      possibleLots: [],
      criteria: [],
      currency: {
        numeral: true,
        delimiter: ' ',
        numeralPositiveOnly: true,
        numeralIntegerScale: 15,
        numeralDecimalScale: 2
      },
      time: {
        time: true,
        timePattern: ['h', 'm'],
        delimiter: ':'
      },
      publication: {
        date: undefined,
        time: undefined,
      },
      saveButtonDisabled: true,
      isReasonRequired: false
    }),

    validations: {
      tender: {
        reason: {
          required: requiredIf(function () {
            return this.isReasonRequired
          })
        },

        changeDescription: {
          required: requiredIf(function () {
            return this.CanChangeDescription
          })
        }
      }
    },

    watch: {
      'tender.publication.time' : {
        handler: function(value) {
          this.publication.date = value;
          this.publication.time = ('00' + value.getHours()).slice(-2) + ('00' + value.getMinutes()).slice(-2);
        }
      },
      'tender.commission': {
        handler: function(commission) {
          let members = [];

          for (let i = 0; i < this.possibleMembers.length; ++i) {
            let isDisabled = false;

            if (_.has(this.possibleMembers[i], 'id') && this.possibleMembers[i].id === +commission.chairman.id) {
              isDisabled = true;
            }

            if (_.has(this.possibleMembers[i], 'id') && this.possibleMembers[i].id === +commission.deputyChairman.id) {
              isDisabled = true;
            }

            if (_.has(this.possibleMembers[i], 'id') && this.possibleMembers[i].id === +commission.secretary.id) {
              isDisabled = true;
            }

            members.push({
              ...this.possibleMembers[i],
              disabled: isDisabled
            });
          }

          this.possibleMembers = members;

        },
        deep: true
      }
    },

    async created() {
      if (this.tender.publication.time) {
        const value = this.tender.publication.time;

        this.publication.date = value;
        this.publication.time = ('00' + value.getHours()).slice(-2) + ('00' + value.getMinutes()).slice(-2);
      }

      this._tender = _.cloneDeep(this.tender);

      await this.runAction(async () => {
        try {
          this.possibleMembers = (await this.$store.dispatch('fetchPossibleCommissionMembers', this.tender)).map(e => ({
            id: e.id,
            name: [e.lastName, e.firstName, e.middleName].join(' ')
          }));

          this.possibleMembers.unshift({ name: 'Не выбран'})
        }
        catch(e) {
          console.error('failed fetching list of possible commission members', e);
          this.globalErrorHandler(e);
        }
      });

      if (this.tender.permissions.CAN_CHANGE_TENDER_ORGANIZER) {
        await this.runAction(async () => {
          try {
            this.organizers = (await this.$store.dispatch('fetchOrganizers')).map(e => ({
              id: e.id,
              name: [e.lastName, e.firstName, e.middleName].join(' '),
              selected: e.id === this.tender.owner.id,
              ...e
            }));

            this.organizers.unshift({ name: 'Не выбран'});
          }
          catch(e) {
            console.error('failed fetching list of organizers', e);
            this.globalErrorHandler(e);
          }
        });
      }

      await this.runAction(async () => {
        try {
          this.documents = await this.$store.dispatch('fetchDocuments');
        }
        catch(e) {
          console.error('failed fetching list of documents', e);
          this.globalErrorHandler(e);
        }
      });

      await this.runAction(async () => {
        try {
          this.possibleLots = await this.$store.dispatch('fetchPossibleLots');
        }
        catch(e) {
          console.error('failed fetching list of possible lots', e);
          this.globalErrorHandler(e);
        }
      });

      await this.runAction(async () => {
        try {
          this.criteria = await this.$store.dispatch('fetchPossibleCriteria');
        }
        catch(e) {
          console.error('failed fetching list of possible criteria', e);
          this.globalErrorHandler(e);
        }
      });

      this.$v.$touch();
    },

    computed: {
      CanEditOwner() {
        return this.tender.permissions.CAN_CHANGE_TENDER_ORGANIZER;
      },

      CanEditName() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER;
      },

      CanEditDurations() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY
            || this.tender.permissions.CAN_EDIT_DURATIONS;
      },

      CanEditTenderMethod() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanEditTenderNumber() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER;
      },

      CanEditPublicationTime() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER;
      },

      CanEditCommission() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_COMMISSION;
      },

      CanEditCriteria() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanEditRetend() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanEditDocuments() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanEditLots() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanEditDocumentation() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanEditOtherOptions() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanEditShowDuration() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
            || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanEditChangeDescription() {
        return this.tender.permissions.CAN_EDIT_FULL_TENDER
          || this.tender.permissions.CAN_EDIT_TENDER_PARTIALLY;
      },

      CanChangeDescription() {
        return this.tender.permissions.CAN_EDIT_CHANGES_IN_TENDER_DESCRIPTION;
      },

      priceCriteria() {
        return [{name: 'Не выбран'}].concat(this.criteria.filter(e => e.type === 'Price' || e.type === 'PriceLot'));
      },

      expertCriteria() {
        return [{name: 'Не выбран'}].concat(this.criteria.filter(e => e.type === 'Expert')).map(p => {
          return {
            ...p,
            disabled: p.id !== undefined && _.some(this.tender.criteria.expert, e => e.id === p.id)
          }
        });
      },

      reductionCriteria() {
        return [{name: 'Не выбран'}].concat(this.criteria.filter(e => e.type === 'Reduction')).map(p => {
          return {
            ...p,
            disabled: p.id !== undefined && _.some(this.tender.criteria.reduction, e => e.id === p.id)
          }
        });
      },

      reducedPriceCriteria() {
        return this.criteria.filter(e => e.type === 'ReducedPrice');
      },

      lots() {
        const lots = [{ name: 'Не выбран'}].concat(this.possibleLots.map(e => ({
          id: e.id,
          name: `№${e.num} ${e.name}`,
          disabled: _.find(this.tender.lots, {id: e.id}) !== undefined
        })));

        return lots;
      },

      totalWeight() {
        return this.tender.criteria.price.reduce((sum, e) => { return sum + +e.weight }, 0)
          + this.tender.criteria.expert.reduce((sum, e) => { return sum + +e.weight }, 0)
          + this.tender.criteria.reduction.reduce((sum, e) => { return sum + +e.weight }, 0)
          + this.tender.criteria.reducedPrice.reduce((sum, e) => { return sum + +e.weight }, 0);
      },

      availableDocuments() {
        return [].concat(this.documents).map(p => {
          return {
            ...p,
            disabled: p.id !== undefined && _.some(this.tender.documents, e => e.id === p.id)
          }
        });
      }
    },

    methods: {
      OnMethodChanged(method) {
        if (this.tender.criteria.reducedPrice.length === 0) {
          const criteria = _.get(this.reducedPriceCriteria, '[0]');

          if (criteria) {
            this.tender.criteria.reducedPrice.push({
              id: criteria.id,
              weight: 0
            });
          }
        }

        this.tender.method = method;

        this.checkForm();
      },

      onDependentDurationChange(ev) {
        this.tender.durations.tender.value =
          this.tender.durations.receivingRequests.value +
          this.tender.durations.reviewingRequests.value +
          this.tender.durations.reviewingRequestsByCriteria.value +
          this.tender.durations.waitingForFirstRetend.value +
          this.tender.durations.splittingPrice.value;

        return this.checkForm(ev);
      },

      async checkForm(event, saveForcibly) {
        this.$v.$touch();

        // update publication time
        if (this.CanEditPublicationTime && this.publication.date && this.publication.time) {
          const d =  new Date(this.publication.date);
          d.setHours(this.publication.time.slice(0, 2), this.publication.time.slice(2));
          this.tender.publication.time = d;
        }

        const changed = !_.isEqual(this.tender, this._tender);
        const doSaveAutomatically = (this.tender.permissions.CAN_EDIT_FULL_TENDER && !this.tender.permissions.CAN_MANUALLY_SAVE_TENDER) || saveForcibly;

        if (this.tender.permissions.CAN_MANUALLY_SAVE_TENDER) {
          this.saveButtonDisabled = !changed;
        }

        if (doSaveAutomatically) {
          this.runAction(async () => {
            try {
              await this.$store.dispatch('updateTender', this.tender);
            }
            catch(e) {
              console.error('failed updating tender', e);

              this.globalErrorHandler(e, {
                'INVALID_LOT': 'errors.tender.common.correct-participant-list-in-according-to-tender-method',
                'ALREADY_EXISTS': 'errors.tender.common.number-is-not-unique',
                'LOGIC_ERROR': 'errors.tender.common.logical-error-while-update-tender'
              });
            }
          });
        }
      },

      async updateTender() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('updateTender', this.tender);
            this.saveButtonDisabled = true;

            if (this.currentUser.isMain) {
              this.showError({
                title: 'Сохранение изменений',
                error: 'Изменение опубликовано на публичной странице лота'
              });
            }
          }
          catch(e) {
            console.error('unable to update tender', e);

            this.globalErrorHandler(e, {
                'INVALID_LOT': 'errors.tender.common.correct-participant-list-in-according-to-tender-method',
                'ALREADY_EXISTS': 'errors.tender.common.number-is-not-unique',
                'LOGIC_ERROR': 'errors.tender.common.logical-error-while-update-tender'
              });

          }
        });
      },

      async onFileReady(file, options) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addFileToTender', {
              tenderId: this.tender.id,
              file: file.file,
              sign: file.sign
            });
          }
          catch(e) {
            console.error('unable to attach file to tender');
            this.globalErrorHandler(e, {
              'BAD_SIGNATURE': 'errors.tender.attaching-file.bad-signature',
            }, 'errors.tender.attaching-file.unknown');
          }
        })
      },

      async onFileRemoveClick(fileId) {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('removeFileFromTender', {
              tenderId: this.tender.id,
              fileId
            });
          }
          catch(e) {
            console.error('unable to remove file from tender');
            this.globalErrorHandler(e);
          }
        })
      },

      async onSignTenderClick() {
        this.runAction(async () => {
          try {
            const text = await this.$store.dispatch('getTenderSigningText', this.tender);
            this.$refs.signTender.open({ text });
          }
          catch(e) {
            console.error('unable to get tender signing text', e);
            this.globalErrorHandler(e, {
              'INVALID_LOT': 'errors.tender.common.correct-participant-list-in-according-to-tender-method',
              'ALREADY_EXISTS': 'errors.tender.common.number-is-not-unique'
            });
          }
        });
      },

      async publishTender(result) {
        this.runAction(async () => {
          try {
            this.$refs.signTender.close();

            await this.$store.dispatch('publishTender', {
              id: this.tender.id,
              text: result.data,
              signature: result.signature
            });
          }
          catch(e) {
            console.error('Unable to publish tender', e)
            this.globalErrorHandler(e);
          }
        });
      },

      async approveTender() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('acceptTender', this.tender);
          }
          catch(e) {
            console.error('Unable to approve tender', e)
            this.globalErrorHandler(e);
          }
        });
      },

      async deleteTender() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('deleteTender', this.tender);
            this.$router.push({ name: 'purchases-tenders'});
          }
          catch(e) {
            console.error('Unable to delete tender', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async declineTender() {
        this.isReasonRequired = true;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            await this.$store.dispatch('declineTender', this.tender);
          }
          catch(e) {
            console.error('Unable to decline tender', e)
            this.globalErrorHandler(e);
          }

          this.isReasonRequired = false;
        });
      },

      async onFileSignCheckClick(fileId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkTenderFileSignature', {
              tenderId: this.tender.id,
              fileId: fileId
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('Unable to check signature of attached to tender file', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onTenderSignCheckClick() {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkTenderSignature', {
              tenderId: this.tender.id
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('Unable to check signature of tender', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async addRequiredDocument() {
        this.tender.documents.push({
          document: {},
          type: this.enums.TenderDocumentType.FOR_REQUEST
        });
      },

      async onRequiredDocumentRemoved(fileIdx) {
        this.runAction(async () => {
          try {
            this.tender.documents.splice(fileIdx, 1);
            this.checkForm();
          }
          catch(e) {
            console.error('unable to remove required document', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onRemoveOtherCommissionMemberClick(idx) {
        this.runAction(async () => {
          try {
            this.tender.commission.other.splice(idx, 1);
            this.checkForm();
          }
          catch(e) {
            console.error('unable to remove other commission member', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .accreditation-modal {
    .registration_doc {
      background-color: #f7f7f7;
      padding: 20px;
      margin-bottom: 20px;

      > div {
        max-height: 200px;
        overflow-y: auto;
      }
    }
  }

  .a-mandatory {
    h3::after,
    .a-label::before {
      content: '*';
      color: #cc061a;
    }
  }
</style>
